
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const SubsidiariesEditor = () => {
  const columns = [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'description_en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description_ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'link', label: 'Link', type: 'text' },
    { key: 'logo', label: 'Logo URL', type: 'image' },
  ];

  return <GenericTableEditor tableName="subsidiaries" columns={columns} title="Subsidiaries Manager" />;
};

export default SubsidiariesEditor;
